import { useFetch } from "data/api/useFetch"

export function useMart(mart?: string, isSlug: boolean = true) {
  const payload = useFetch(
    `/v2/internal/marts/${mart}${isSlug ? "?param=slug" : ""}` as `/v2/internal/marts/:slug`,
    !!mart
  )

  return payload ? payload.data : null
}
